/**
 * Created by Mikhail Menshenin on 06.02.2026
 */

let LevelMasteryView;

if (["playrix", "empire", "simple"].includes(cleverapps.config.ui)) {
    LevelMasteryView = LevelMasteryPrefabView;
}
